// ====== 长任务拆分工具函数 ======
function runTaskInChunks(tasks, chunkSize = 5) {
  let index = 0;
  
  function processChunk() {
    const start = Date.now();
    while (index < tasks.length && (Date.now() - start) < 15) {
      if (typeof tasks[index] === 'function') {
        tasks[index]();
      }
      index++;
    }
    
    if (index < tasks.length) {
      setTimeout(processChunk, 0);
    }
  }
  
  processChunk();
}

// ====== 初始化任务队列 ======
document.addEventListener('DOMContentLoaded', () => {
  // 1. 收集需要初始化的任务
  const initTasks = [];
  
  // 2. 添加头部初始化任务
  if (typeof initHeader === 'function') {
    initTasks.push(initHeader);
  }
  
  // 3. 添加产品网格初始化任务
  if (typeof initProductGrid === 'function') {
    initTasks.push(initProductGrid);
  }
  
  // 4. 添加购物车初始化任务
  if (typeof initCart === 'function') {
    initTasks.push(initCart);
  }
  
  // 5. 添加其他自定义任务
  // initTasks.push(yourCustomFunction);
  
  // 6. 使用分块执行
  if (initTasks.length > 0) {
    runTaskInChunks(initTasks);
  }
});